// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-name[data-v-5f788447]{flex-wrap:nowrap;overflow:hidden;width:100%}.truncated-filename[data-v-5f788447]{overflow:hidden;text-overflow:ellipsis;color:#a4aeb9}.truncated-filename span[data-v-5f788447]{color:#1b3550}.file-name[data-v-5f788447],.truncated-filename[data-v-5f788447],.extension[data-v-5f788447]{margin:0;white-space:nowrap}", ""]);
// Exports
module.exports = exports;
